import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_SUMMARY',
    'FETCH_SUMMARY_SUCCESS',
    'FETCH_SEM_SUMMARY',
    'FETCH_CHANNEL_SUMMARY',
    'FETCH_CHANNEL_SUMMARY_SUCCESS',
    'FETCH_ACTIVITIES',
    'FETCH_ACTIVITIES_SUCCESS',
    'RESET_TO_INITIAL_STATE'
], 'LAYER_TWO');


// Action Creators
export const fetchLayerTwoSummary = createAction(actions.FETCH_SUMMARY, params => params);
export const layerTwoSummaryFetched = createAction(actions.FETCH_SUMMARY_SUCCESS, data => data);
export const fetchLayerTwoChannelSummary = createAction(actions.FETCH_CHANNEL_SUMMARY, params => params);
export const fetchLayerTwoSEMSummary = createAction(actions.FETCH_SEM_SUMMARY, params => params);
export const layerTwoChannelSummaryFetched = createAction(actions.FETCH_CHANNEL_SUMMARY_SUCCESS, data => data);
export const fetchLayerTwoActivities = createAction(actions.FETCH_ACTIVITIES, params => params);
export const layerTwoActivitiesFetched = createAction(actions.FETCH_ACTIVITIES_SUCCESS, data => data);
export const resetLayerTwoInitialState = createAction(actions.RESET_TO_INITIAL_STATE);

// Reducers
const initialSummaryState = {
    data: null,
    hasData: null
};

const initialState = {
    entity: {
        summary: {
            data: null,
            hasData: null // defaulting to null to indicate we are fetching data and don't know if we have data or not.
        }
    },
    display: {
        summary: initialSummaryState
    },
    mobile: {
        summary: initialSummaryState
    },
    native: {
        summary: initialSummaryState
    },
    video: {
        summary: initialSummaryState
    },
    sem: {
        summary: initialSummaryState
    },
    audio: {
        summary: initialSummaryState
    },
    tv: {
        summary: initialSummaryState
    },
    site: {
        summary: initialSummaryState
    },
    social: {
        summary: initialSummaryState
    },
    activities: {
        keys: null,
        hasData: null,
        data: null,
        rankings: null,
        categories: null,
        xAxisLabel: null
    }
};

export default handleActions({

    [actions.FETCH_SUMMARY_SUCCESS]: (state, action) => {
        const { hasData } = action.payload.params;

        if (hasData) {
            const updatedData = {
                entity: {
                    summary: {
                        data: { $set: action.payload.data },
                        hasData: { $set: hasData }
                    }
                }
            };
            return update(state, updatedData);
        }

        const updatedData = { entity: { summary: { hasData: { $set: hasData } } } };
        return update(state, updatedData);
    },

    [actions.FETCH_ACTIVITIES_SUCCESS]: (state, action) => {
        const { hasData } = action.payload.params;

        if (hasData) {
            const dataKeys = Object.keys(action.payload.entities);
            const scopeKey = action.payload.categories.config.selector;

            const data = {};
            dataKeys.forEach((entity) => {
                if (action.payload[entity]) {
                    data[entity] = {
                        statistics: action.payload[entity].statistics,
                        items: action.payload[entity][scopeKey]
                    };
                }
            });
            const updatedData = {
                keys: { $set: action.payload.entities },
                hasData: { $set: hasData },
                data: { $set: data },
                rankings: { $set: action.payload.rankings },
                categories: { $set: action.payload.categories[scopeKey] },
                xAxisLabel: { $set: action.payload.categories.config.xAxisLabel }
            };

            return update(state, {
                activities: updatedData
            });
        }

        const updatedData = {
            hasData: { $set: hasData }
        };

        return update(state, {
            activities: updatedData
        });
    },

    [actions.FETCH_CHANNEL_SUMMARY_SUCCESS]: (state, action) => {
        const { hasData, channel } = action.payload.params;

        if (hasData) {
            const updatedData = {
                [channel]: {
                    summary: {
                        data: { $set: action.payload },
                        hasData: { $set: hasData }
                    }
                }
            };

            return update(state, updatedData);
        }

        const updatedData = { [channel]: { summary: { hasData: { $set: hasData } } } };
        return update(state, updatedData);
    },

    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState })

}, initialState);



// WEBPACK FOOTER //
// ./src/services/layerTwo/duck.js